
import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { messageList, deleteMessage, readMessage } from '@/services/http';
import { dateTimeFormatter } from '@/tools/tools';
import NavMenu from '@/common/navmenu.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';

@Component({
  components: {
    Header,
    NavMenu,
    Footer
  },
  filters: {
    dateTime(value: number) {
      return dateTimeFormatter(value);
    }
  }
})
export default class extends Vue {
  // state
  messageType: string = '1'

  isloading: boolean = false

  isEdit: boolean = false

  messageList: any[] = []

  // 发货通知数量
  deliverNumber: number = 0

  // 商城消息数量
  mallNumber: number = 0

  isAll: boolean = false

  isHasText: boolean = false

  // 当前页数
  currentpage: number = 1

  // 总条数
  totalnumber: number = 20

  pageNo: number = 1

  pageSize: number = 10

  @State('notifys') notifysState: any

  @Action('notifys/messageSimple') messageSimple!: Function

  created() {
    this.getMessageList();
  }

  handleClick() {
    this.messageList = [];
    this.getMessageList();
  }

  // 取消选择
  cancelChoose() {
    this.isEdit = false;
  }

  // 编辑消息
  editMessage() {
    this.isEdit = true;
  }

  //  删除消息
  async deleteMessage() {
    const arr = this.messageList.filter((value) => value.checked && value.id);
    if (arr.length === 0) {
      this.$message.error('请先勾选消息');
    } else {
      const ids = arr.map((value) => value.id).join(',');
      const res: any = await deleteMessage({
        messageType: this.messageType,
        messageIds: ids
      });
      if (res.data.code === 100) {
        this.isEdit = false;
        this.messageList = [];
        this.getMessageList();
        this.$message.success('删除成功');
      } else {
        this.$message.error(res.data.message);
      }
    }
  }

  //  async getMessageSimple() {
  //    const res: any = await messageSimple();
  //    this.deliverNumber = res.data.data.sendGoodsMsgNum;
  //    this.mallNumber = res.data.data.optGoodsMsgNum;
  //  }

  private async getMessageList() {
    const res: any = await messageList({
      messageType: this.messageType,
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      companyId: 1
    });
    res.data.data.list.forEach((ele: any) => {
      this.$set(ele, 'checked', false);
    });
    this.messageList = [...this.messageList, ...res.data.data.list];
    this.isHasText = this.messageList.length !== 0;
    this.totalnumber = res.data.data.total;
    this.messageSimple();
  }

  private handleSelect(index: number) {
    this.messageList[index].checked = !this.messageList[index].checked;
    this.isAll = this.messageList.every((e) => e.checked);
  }

  handleSizeChange(val: number) {
    this.messageList = [];
    this.pageSize = val;
    this.getMessageList();
  }

  handleCurrentChange(pageNo: number) {
    this.messageList = [];
    this.pageNo = pageNo;
    this.getMessageList();
    window.scrollTo(0, 0);
  }

  // 全选
  handleAllSelect() {
    this.isAll = !this.isAll;
    this.messageList.forEach((ele: any) => {
      this.$set(ele, 'checked', this.isAll);
    });
  }

  // 未读消息
  goDetails(serverId: string, id: string, index: number) {
    readMessage({
      messageType: this.messageType,
      messageId: id
    });
    if (index === 0) {
      this.$router.push(`/order-details?id=${serverId}`);
    } else {
      this.$router.push(`/details?id=${serverId}`);
    }
  }
}
